import Footer from "@/components/Footer/Footer.tsx";
import Nav from "@/components/Header/Nav/Nav.tsx";
import { useEffect, useState, Suspense } from "react";
import FaqBlock from "@/components/FAQ/FAQBlock";
import CookiePopupButton from "../components/CookieBanner/CookiePopupButton";

// Тип для секції FAQ
interface FaqSection {
  title: string;
  data: any[];
}

const FAQ = () => {
  const [faqSections, setFaqSections] = useState<FaqSection[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [visibleSections, setVisibleSections] = useState<number>(2); // Початкова кількість секцій для завантаження

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Функція для динамічного завантаження секцій
  const loadFaqSections = async (sectionsToLoad: number) => {
    setIsLoading(true);

    const loadedSections: FaqSection[] = [];

    try {
      // Динамічно імпортуємо тільки необхідні секції
      if (sectionsToLoad >= 1) {
        const { faqData1, faqTitle1 } = await import("@/data/faq/faqData1.de");
        loadedSections.push({ title: faqTitle1, data: faqData1 });
      }

      if (sectionsToLoad >= 2) {
        const { faqData2, faqTitle2 } = await import("@/data/faq/faqData2.de");
        loadedSections.push({ title: faqTitle2, data: faqData2 });
      }

      if (sectionsToLoad >= 3) {
        const { faqData3, faqTitle3 } = await import("@/data/faq/faqData3.de");
        loadedSections.push({ title: faqTitle3, data: faqData3 });
      }

      if (sectionsToLoad >= 4) {
        const { faqData4, faqTitle4 } = await import("@/data/faq/faqData4.de");
        loadedSections.push({ title: faqTitle4, data: faqData4 });
      }

      if (sectionsToLoad >= 5) {
        const { faqData5, faqTitle5 } = await import("@/data/faq/faqData5.de");
        loadedSections.push({ title: faqTitle5, data: faqData5 });
      }

      if (sectionsToLoad >= 6) {
        const { faqData6, faqTitle6 } = await import("@/data/faq/faqData6.de");
        loadedSections.push({ title: faqTitle6, data: faqData6 });
      }

      if (sectionsToLoad >= 7) {
        const { faqData7, faqTitle7 } = await import("@/data/faq/faqData7.de");
        loadedSections.push({ title: faqTitle7, data: faqData7 });
      }

      setFaqSections(loadedSections);
    } catch (error) {
      console.error("Помилка завантаження секцій FAQ:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Спочатку завантажуємо тільки перші 2 секції
    loadFaqSections(visibleSections);
  }, [visibleSections]);

  // Функція для перевірки, чи досяг низу сторінки
  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop >=
      document.documentElement.offsetHeight - 200
    ) {
      // Якщо досягли нижчої частини сторінки (з запасом 200px), завантажуємо ще одну секцію
      if (visibleSections < 7 && !isLoading) {
        setVisibleSections((prev) => Math.min(prev + 1, 7)); // Завантажуємо по 1 секції за раз
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [visibleSections, isLoading]);

  return (
    <div>
      <title>F.A.Q – HIXA – DSG Getriebe Reparatur & Wartung</title>
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      <Nav />
      <div className="sectionPage container">
        <div className="sectionTitle sideP88 borderNo">
          <h1 id="brxeJzewul" className="top60">
            Alle Fragen und Antworten
          </h1>
        </div>
      </div>

      {/* Рендеримо завантажені секції */}
      <Suspense fallback={<div>Loading section...</div>}>
        {faqSections.map((section, index) => (
          <div key={index}>
            <FaqBlock faqData={section.data} title={section.title} />
          </div>
        ))}
      </Suspense>

      {isLoading && <div>Loading...</div>}
      <CookiePopupButton></CookiePopupButton>
      <Footer />
    </div>
  );
};

export default FAQ;
